import React from 'react';
import { PREMIUM_MOCKUP_IMAGE } from '../../data/site';
export function BundleMockup() {
  return <figure className="mx-auto w-full max-w-[480px]" data-id="element-128" data-mp="1tp3gqvhxuszs">
      <img src={PREMIUM_MOCKUP_IMAGE} alt="Illustrative Handball Class Ready boxed set: 12 lessons and the five included digital bonuses" loading="lazy" width={1374} height={1145} className="block h-auto w-full rounded-xl border border-slate-200" data-id="element-129" data-mp="1tmqz6jg3ekn9" />
      <figcaption className="mt-2 text-center text-xs text-slate-500" data-id="element-130" data-mp="15xfy10utyo8l">Illustrative mockup of the digital pack.</figcaption>
    </figure>;
}